// pages/notes/index.jsx
import React, { useEffect, useState } from 'react'
import Layout from './layout'

export default function NotesPage() {
  const files = [
    { filename: '2021-09-01_React.md', path: '/notes/2021-09-01_React' },
    { filename: '2021-09-02_NextJS.md', path: '/notes/2021-09-02_NextJS' },
    { filename: '2021-09-03_TailwindCSS.md', path: '/notes/2021-09-03_TailwindCSS' },
    { filename: '2021-09-04_React-Router.md', path: '/notes/2021-09-04_React-Router' },
    { filename: '2021-09-05_React-Hooks.md', path: '/notes/2021-09-05_React-Hooks' },
    { filename: '2021-09-06_React-Context.md', path: '/notes/2021-09-06_React-Context' },
    { filename: '2021-09-07_React-Redux.md', path: '/notes/2021-09-07_React-Redux' },
    { filename: '2021-09-08_React-Query.md', path: '/notes/2021-09-08_React-Query' },
    { filename: '2021-09-09_React-Testing.md', path: '/notes/2021-09-09_React-Testing' },
    { filename: '2021-09-10_React-Performance.md', path: '/notes/2021-09-10_React-Performance' },
    { filename: '2021-09-11_React-Server-Side-Rendering.md', path: '/notes/2021-09-11_React-Server-Side-Rendering' },
    { filename: '2021-09-12_React-Static-Site-Generation.md', path: '/notes/2021-09-12_React-Static-Site-Generation' },
    { filename: '2021-09-13_React-Deployment.md', path: '/notes/2021-09-13_React-Deployment' },
    { filename: '2021-09-14_React-Optimization.md', path: '/notes/2021-09-14_React-Optimization' },
    { filename: '2021-09-15_React-SEO.md', path: '/notes/2021-09-15_React-SEO' },
  ]
  return (
    <Layout>
      <h1 className="notes-h1">
        <a href="/">🏡 Home </a> | 📚 Notes | <a href="/fragments">♻️ Fragments</a>
      </h1>
      <div className="notes-list h-full">
        <ul>
          {files.map((file) => (
            <li key={file.filename}>
              <a href={`${file.path}_`}>
                {file.filename.replaceAll('_', '-').substring(0, 10)}{' '}
                {file.filename.replaceAll('_', ' ').substring(10).replaceAll('.md', '')}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div style={{ display: 'none' }}>
        <h1>.</h1>
        <h2>.</h2>
        <h3>.</h3>
        <h4>.</h4>
        <h5>.</h5>
        <h6>.</h6>
        <p>.</p>
        <ol>
          <li>.</li>
        </ol>
        <ol start="2">
          <li>
            <strong>Query Data</strong>:
            <ul>
              <li>The actual data fetched from the server (or provided manually).</li>
              <li>
                Stored until the query is garbage-collected (based on <code>cacheTime</code>).
              </li>
            </ul>
          </li>
          <li>
            <strong>Query Metadata</strong>:
            <ul>
              <li>
                Stores the state of the query:
                <ul>
                  <li>
                    <code>status</code>: Indicates if the query is <code>idle</code>, <code>loading</code>,{' '}
                    <code>error</code>, or <code>success</code>.
                  </li>
                  <li>
                    <code>fetchStatus</code>: Shows whether data is actively being fetched (<code>fetching</code>,{' '}
                    <code>paused</code>, etc.).
                  </li>
                  <li>
                    <code>isStale</code>: Marks if the data is considered stale (based on <code>staleTime</code>).
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <strong>Observers</strong>:
            <ul>
              <li>
                Each query can have multiple observers (e.g., <code>useQuery</code> instances).
              </li>
              <li>A query stays active as long as it has active observers.</li>
              <li>Observers receive updates when the query data changes.</li>
            </ul>
          </li>
          <li>
            <strong>Stale Time</strong>:
            <ul>
              <li>Time (in ms) before the data is marked as stale.</li>
              <li>Stale queries trigger a refetch when accessed or under specific conditions.</li>
            </ul>
          </li>
          <li>
            <strong>Cache Time</strong>:
            <ul>
              <li>
                Time (in ms) a query remains in the cache after it becomes inactive (i.e., has no active observers).
              </li>
            </ul>
          </li>
          <li>
            <strong>Retry Logic</strong>:
            <ul>
              <li>Configurable retry attempts and delay for failed queries.</li>
              <li>
                Managed by the <code>retry</code> and <code>retryDelay</code> options.
              </li>
            </ul>
          </li>
        </ol>
      </div>
    </Layout>
  )
}
